export default "__VITE_ASSET__BG8j_8bt__"